import SnackbarContent, { SnackbarContentProps } from '@mui/material/SnackbarContent';

export { SnackbarContent, SnackbarContentProps };
